import { Button, lightColors } from '@tryhackme/thm-ui-components';
import type { ArrowPosition } from '@tryhackme/thm-ui-components/dist/components/atoms/tooltip/tooltip.types';
import styled from 'styled-components';
import type { TooltipPositionType } from './helper-tooltip.types';
export const StyledHelperToolTipWrapper = styled.div<Pick<TooltipPositionType, 'bottom' | 'left' | 'right' | 'top'>>`
  position: absolute;

  ${({
  top,
  bottom,
  left,
  right
}) => ({
  ...(top && {
    top
  }),
  ...(bottom && {
    bottom
  }),
  ...(left && {
    left
  }),
  ...(right && {
    right
  })
})};
  z-index: 200;
  transition: all 0.3s ease-in-out;
  min-width: 20rem;
`;
export const StyledHelperToolTipText = styled.div`
  margin: 0;
`;
export const StyledHelperToolTipButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  margin-top: 2.4rem;
`;
export const StyledHelperToolTipBackButton = styled(Button)`
  margin-right: 1.6rem;
`;
export const StyledTooltipOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  inset: 0;
  z-index: 3;
`;
export const StyledHelperTooltipWrapper = styled.div<{
  arrowPosition?: ArrowPosition;
}>`
  div[role='tooltip'] {
    background-color: ${() => lightColors.background.tertiary};
    color: ${() => lightColors.text.main};
    max-width: 32.3rem;
    min-width: 32.3rem;
  }
  & div::before {
    ${({
  arrowPosition
}) => arrowPosition === 'right' ? `border-left-color:${lightColors.background.tertiary};` : `border-bottom-color: ${lightColors.background.tertiary};`};
  }
  button[color='secondary'] {
    ${() => `
      background-color: transparent;
      border-color: ${lightColors.button.secondary.border};
      color: ${lightColors.text.main};
      &:hover:not(:disabled) {
        background-color: ${lightColors.button.secondary.hover};
        color: ${lightColors.secondary.dark};
      }
  `}
  }
`;